import { useLocalObservable } from 'mobx-react-lite'
import { Address } from '../../types'
import { createContext, useContext } from 'react'


const AddressContext = createContext(null as any);

export const AppStoreProvider = ({ children }: { children: any }) => {
    const store = useLocalObservable(() => ({
        address: {} as Address,
        setAddress(address: Address) {
            store.address = address;
        },
        getAddress() {
            return store.address;
        },
    }));

    return (
        <AddressContext.Provider value={store}>
            {children}
        </AddressContext.Provider>
    );
};

export const useMyStore = () => {
    const store = useContext(AddressContext);
    if (!store) {
        throw new Error("useMyStore must be used within an AddressProvider");
    }
    return store;
};